<div class="login-page-wrapper">
<div class="login-page">
  <div class="login-content" fxLayout="column">
    <img
      class="logo"
      src="/assets/image/kinetiq-ad-verification.png"
      alt="Kinetiq Ad Verification logo"
    />
    <p class="rebrand-copy">
      Kinetiq Ad Verification, formerly VEIL Global Technologies, Inc, helps brands, agencies, and performance
      marketers accurately verify TV campaign delivery through deterministic audio watermarking technology.
    </p>

    <hr class="login-divider" />

    <div class="welcome-block">
      <h2 class="welcome-heading">Welcome back</h2>
      <p class="welcome-subtext">Enter your credentials to access your account</p>
    </div>

    <form #loginForm="ngForm" class="login-form" fxLayout="column" fxLayoutAlign="center center">
      <div class="field-label-row" fxFlex.xs="100%" fxFlex="70%">
        <label class="field-label">Email address</label>
      </div>
      <mat-form-field appearance="outline" class="login-field" fxFlex.xs="100%" fxFlex="70%">
        <input
          matInput
          type="email"
          placeholder="Enter your email"
          [(ngModel)]="model.email"
          #email="ngModel"
          name="email"
          email
          required
          cdk
        />
        <mat-error *ngIf="email.invalid && (email.touched || email.dirty)">
          <div *ngIf="email.errors.email && !email.errors.required">
            Enter a valid email address
          </div>
          <div *ngIf="email.errors.required">
            Email is required
          </div>
        </mat-error>
      </mat-form-field>
      <div class="field-label-row" fxFlex.xs="100%" fxFlex="70%">
        <label class="field-label">Password</label>
      </div>
      <mat-form-field appearance="outline" class="login-field" fxFlex.xs="100%" fxFlex="70%">
        <input
          matInput
          placeholder="Enter your password"
          [(ngModel)]="model.password"
          #password="ngModel"
          name="password"
          type="password"
          required
        />
        <mat-error *ngIf="password.invalid && (password.touched || password.dirty)">
          <div *ngIf="password.errors.required">
            Password is required
          </div>
        </mat-error>
      </mat-form-field>
      <div class="forgot-link-row" fxFlex.xs="100%" fxFlex="70%" fxLayout="row" fxLayoutAlign="end center">
        <a mat-button color="primary" class="forgot-link" routerLink="/forgot-password">forgot password</a>
      </div>
      <div class="login-button-row">
        <button
          mat-raised-button
          class="login-button"
          [disabled]="!loginForm.form.valid"
          type="submit"
          (click)="login()"
          color="primary"
        >
          Log In
        </button>
      </div>
    </form>
  </div>
</div>

<footer class="login-footer">
  <div class="login-footer-container">
    <nav class="login-footer-nav" fxLayout="row" fxLayoutGap="24px" fxLayoutGap.xs="16px" fxLayout.xs="column">
      <a href="https://kinetiq.tv/" target="_blank">Home</a>
      <a href="https://kinetiq.tv/tv-detection-attribution/" target="_blank">Solutions</a>
      <a href="https://kinetiq.tv/resources/" target="_blank">Resources</a>
      <a href="https://kinetiq.tv/company/" target="_blank">Company</a>
      <a href="https://live-kinetiqtv.pantheonsite.io/careers/" target="_blank">Careers</a>
    </nav>

    <hr class="login-footer-divider" />

    <div
      class="login-footer-bottom"
      fxLayout="row"
      fxLayoutAlign="space-between start"
      fxLayout.xs="column"
      fxLayoutAlign.xs="center center"
      fxLayoutGap.xs="12px"
    >
      <div class="login-footer-legal" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">
        <a href="https://kinetiq.tv/privacy-policy/" target="_blank">Privacy Policy</a>
        <a href="https://kinetiq.tv/copyright-abuse/" target="_blank">Copyright Abuse</a>
        <a href="https://kinetiq.tv/security-policy/" target="_blank">Security Policy</a>
        <span class="login-footer-copyright">&copy; {{ currentYear }} Kinetiq. All rights reserved.</span>
      </div>
      <div class="login-footer-social" fxLayout="row" fxLayoutGap="8px">
        <a
          href="https://www.linkedin.com/company/kinetiq-tv"
          target="_blank"
          class="login-footer-icon"
          aria-label="Kinetiq on LinkedIn"
        >
          <i class="fab fa-linkedin"></i>
        </a>
        <a href="https://kinetiq.tv/contact/" target="_blank" class="login-footer-icon" aria-label="Contact Kinetiq">
          <i class="fa fa-envelope"></i>
        </a>
      </div>
    </div>
  </div>
</footer>
</div>
